export default function ProjectImage({ src, alt, title }) {
  const handleImageClick = () => {
    // Calculate center position
    const width = 800;
    const height = 600;
    const left = (window.screen.width - width) / 2;
    const top = (window.screen.height - height) / 2;

    // Open centered popup window
    window.open(
      src,
      'imagePopup',
      `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes,status=no,toolbar=no,menubar=no,location=no`
    );
  };

  return (
    <div 
      className="w-56 h-56 flex-shrink-0 bg-gray-900/20 rounded-lg cursor-pointer hover:scale-105 transition-transform"
      onClick={handleImageClick}
    >
      <img 
        src={src} 
        alt={alt} 
        title={title}
        className="w-full h-full object-contain rounded-lg"
      />
    </div>
  );
}